export const faqs = [
  {
    q: 'What exactly is DENTAL PREDICTABILITY ROADMAP™?',
    a: [
      'It’s a six-volume digital clinical reference collection focused on clear aligner movement predictability, treatment planning, biomechanics, digital setup evaluation, clinical decision-making, and treatment monitoring.',
      'Your purchase also includes five complementary clinical planning resources.',
    ],
  },
  {
    q: 'Who is this collection designed for?',
    a: [
      'It’s intended for licensed dentists, orthodontists, and qualified dental professionals involved in clear aligner treatment planning.',
      'The materials are educational and should be used within your professional scope of practice.',
    ],
  },
  {
    q: 'Can I use these principles with different clear aligner brands?',
    a: [
      'The collection focuses on general biomechanical and clinical planning principles that may be relevant across different clear aligner systems.',
      'However, appliance design, software capabilities, material properties, and manufacturer protocols can vary. Always consider the requirements of the specific system you’re using.',
    ],
  },
  {
    q: 'Do I need special software?',
    a: [
      'The collection is designed as a digital reference resource. The ebooks are provided in PDF format for viewing on common devices, and printable worksheets are also provided as PDF files.',
      'You don’t need specialized orthodontic planning software simply to read the materials.',
    ],
  },
  {
    q: 'Will this eliminate refinements?',
    a: [
      'No educational resource can guarantee that refinements will be eliminated.',
      'Treatment outcomes depend on multiple factors, including diagnosis, biomechanics, patient characteristics, compliance, and clinical execution. The roadmap is designed to help you evaluate relevant factors more systematically.',
    ],
  },
  {
    q: 'Is this suitable for general dentists?',
    a: [
      'General dentists with appropriate training and authorization to provide clear aligner treatment may find the planning references useful.',
      'The collection does not replace formal orthodontic education, specialist consultation, or applicable professional requirements.',
    ],
  },
  {
    q: 'How will I receive the materials?',
    a: ['You receive digital access right after purchase.'],
  },
  {
    q: 'Can I download the ebooks?',
    a: [
      'Yes. The collection is delivered as downloadable digital reference materials.',
      'You can save the files on compatible devices for personal professional reference, subject to the purchase license.',
    ],
  },
  {
    q: 'Is this a monthly subscription?',
    a: ['No. The purchase price is a one-time payment of $27. There are no monthly subscription charges for the purchased collection.'],
  },
  {
    q: 'Does my access expire?',
    a: ['The offer includes lifetime access to the purchased digital materials, subject to the final delivery and access terms.'],
  },
  {
    q: 'Is there a refund guarantee?',
    a: ['Yes. The offer includes a seven-day refund period, according to the published refund policy.'],
  },
  {
    q: 'Can I use this collection outside the United States?',
    a: [
      'The general educational principles may be useful internationally.',
      'However, professional regulations, clinical standards, product availability, and treatment protocols differ by country. Always follow the requirements applicable to your jurisdiction.',
    ],
  },
];
